import { render, staticRenderFns } from "./mdProductClass.vue?vue&type=template&id=4b033a24&scoped=true&"
import script from "./mdProductClass.vue?vue&type=script&lang=js&"
export * from "./mdProductClass.vue?vue&type=script&lang=js&"
import style0 from "./mdProductClass.vue?vue&type=style&index=0&id=4b033a24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b033a24",
  null
  
)

export default component.exports